<template>
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header
        :breadcrumbs="[{ name: '各種設定' }, { name: 'スカウトテンプレート一覧', pathName: 'settingScoutTemplates' }]"
        :title="`スカウトテンプレート${formTypeLabel}`"
        data-test="title"
      />
      <div class="boss-scout-send-container">
        <form-item
          v-model="message.name"
          data-test="text-template-title"
        >
          <template #label>
            テンプレート名<br>
            <small>（50文字以内）</small>
          </template>
        </form-item>
        <scout-mail-form
          v-model="message"
          @change-invalid="changeInvalid"
        />
      </div>
      <form-button-area>
        <form-confirm-button
          :is-disabled="isConfirmButtonDisabled"
          :submit-label="`この内容でテンプレートを${formTypeLabel}する`"
          data-test="confirm-button"
          @submit-event="onRegisterClick"
        />
      </form-button-area>
    </div>
  </div>
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import ScoutMailForm from '@/components/molecules/ScoutMailForm'
import FormButtonArea from '@/components/atoms/FormButtonArea'
import FormConfirmButton from '@/components/atoms/FormConfirmButton'
import FormItem from '@/components/atoms/FormItem'

export default {
  components: {
    SettingHeader,
    ScoutMailForm,
    FormItem,
    FormButtonArea,
    FormConfirmButton
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      message: {
        name: '新規テンプレート',
        subject: '',
        body: '',
        specialFavorIds: []
      },
      isMessageInvalid: true
    }
  },
  computed: {
    isEmptyTemplate () {
      return this.message.name.trim().length === 0
    },
    isConfirmButtonDisabled () {
      return this.isMessageInvalid ||
        this.isEmptyTemplate
    },
    formTypeLabel () {
      return this.id ? '編集' : '登録'
    }
  },
  created () {
    this.id && this.fetchScoutTemplate()
  },
  methods: {
    fetchScoutTemplate () {
      this.$http.secured.get(`/company/scout/message/templates/${this.id}`)
        .then(response => {
          this.$set(this.message, 'name', response.data.name)
          this.$set(this.message, 'subject', response.data.subject)
          this.$set(this.message, 'body', response.data.body)
          this.$set(this.message, 'specialFavorIds', response.data.specialFavorIds)
        })
    },
    onRegisterClick () {
      this.$emit('submit', this.message)
    },
    changeInvalid (isInvalid) {
      this.$set(this, 'isMessageInvalid', isInvalid)
    }
  }
}
</script>
